module.exports = __webpack_public_path__ + "images/7857f2d281c1edc320bc978089313c7c.png";